import { alpha, useTheme } from '@mui/material/styles';
import { SimTypography } from 'components/SimTypography';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';

const ABATherapySummary = () => {
	const theme = useTheme();

	return (
		<Box>
			<Box
				sx={{
					backgroundImage: `linear-gradient(${alpha(theme.palette.divider.dark, 1)} 0%, ${alpha(
						theme.palette.background.default,
						0
					)} 100%)`
				}}>
				<Box
					display='flex'
					justifyContent='center'
					alignItems={'center'}
					alignContent='center'
					height={1}
					width={1}>
					<Box
						paddingX={2}
						width={1}
						sx={{
							bgcolor: 'rgba(0, 0, 0, 0)'
						}}
						display='flex'
						justifyContent='center'
						alignContent={'center'}
						alignItems={'center'}>
						<Container>
							<Box>
								{/*
								<SimTypography
									color={theme.palette.secondary.main}
									sx={{
										textTransform: 'uppercase',
										fontWeight: 'medium'
									}}
									gutterBottom
									align={'left'}>
									OFFERING
								</SimTypography>
								*/}

								<SimTypography
									color={theme.palette.text.primary}
									variant='h3'
									align={'left'}
									paddingcenter='2vw'
									data-aos={'fade-up'}
									gutterBottom
									sx={{
										fontWeight: 700,
										marginTop: theme.spacing(1)
									}}>
									ABA Therapy
								</SimTypography>

								<SimTypography
									color={theme.palette.primary.main}
									variant='h6'
									align={'left'}
									data-aos={'fade-up'}>
									Early intervention is{' '}
									<Box component='span' color={theme.palette.secondary.mainOrange}>
										CRITICAL
									</Box>
								</SimTypography>

								{/*
								<Box display='flex' justifyContent={'left'} marginTop={2}>
									<Button
										variant='contained'
										size='large'
										href={'/contact'}
										endIcon={
											<Box
												component={'svg'}
												xmlns='http://www.w3.org/2000/svg'
												fill='none'
												viewBox='0 0 24 24'
												stroke='currentColor'
												width={24}
												height={24}>
												<path
													strokeLinecap='round'
													strokeLinejoin='round'
													strokeWidth={2}
													d='M17 8l4 4m0 0l-4 4m4-4H3'
													color={theme.palette.background.default}
												/>
											</Box>
										}>
										Start now
									</Button>
								</Box>
								*/}
							</Box>
						</Container>
					</Box>
				</Box>
			</Box>
		</Box>
	);
};

export { ABATherapySummary };
